@if (conditionsLoaded()) { @if (mode === 'select') {
<mat-form-field class="w-full">
  <mat-label>Conditions</mat-label>
  <mat-select
    [disabled]="formControl.disabled"
    [formControl]="formControl"
    [multiple]="multiSelect"
  >
    @for ( condition of filter === 'VEHICLE' ? vehicleConditions : filter ===
    'DRIVER' ? driverConditions : filter === 'TRAVELLER' ? travellerConditions :
    filter === 'BOOKING' ? jobConditions : filter === 'ORGANISATION' ?
    organisationConditions : filter === 'MEDALLION' ? medallionConditions : null
    ; track condition) {
    <mat-option [value]="condition"> {{ condition.name }}</mat-option>
    }
  </mat-select>
</mat-form-field>
} @if (mode === 'list') {
<div
  class="flex flex-col"
  [class.-mt-4]="inSearchForm() && !conditionsLabel"
>
  @if (conditionsLabel) {
  <mat-label class="text-sm font-light">{{ conditionsLabel }}</mat-label>
  }
  @if (groupByAssignmentMode()) {
  <div
    class="flex flex-col gap-1 compact-checkboxes"
    [class.!pt-0]="inSearchForm()"
  >
    @for (group of assignmentModeGroups(); track group.assignmentMode) {
    <div class="flex flex-col">
      <mat-checkbox
        class="text-sm font-semibold"
        [disabled]="formControl.disabled"
        [checked]="isAssignmentGroupChecked(group)"
        [indeterminate]="isAssignmentGroupIndeterminate(group)"
        (change)="toggleAssignmentGroup(group, $event.checked)"
      >
        {{ group.label }}
      </mat-checkbox>
      <div class="flex flex-col pl-6">
        @for (condition of group.conditions; track condition.networkConditionId)
        {
        <mat-checkbox
          class="text-sm font-medium"
          [disabled]="formControl.disabled"
          [checked]="isConditionSelected(condition.networkConditionId)"
          (change)="
            toggleConditionSelection(condition.networkConditionId, $event.checked)
          "
        >
          {{ condition.name }}
        </mat-checkbox>
        }
      </div>
    </div>
    }
  </div>
  } @else {
  <mat-selection-list
    [formControl]="formControl"
    #conditionSelectionList
    class="grid condensed-leading-checkbox-selection-list"
    [ngClass]="'grid-cols-' + columns"
    [class.!pt-0]="inSearchForm()"
    [class.!pb-0]="inSearchForm()"
  >
    @for ( condition of filter === 'VEHICLE' ? vehicleConditions : filter ===
    'DRIVER' ? driverConditions : filter === 'TRAVELLER' ? travellerConditions :
    filter === 'BOOKING' ? jobConditions : filter === 'ORGANISATION' ?
    organisationConditions : filter === 'MEDALLION' ? medallionConditions : null
    ; track condition) {
    <mat-list-option
      [disabled]="formControl.disabled"
      checkboxPosition="before"
      [value]="condition.networkConditionId"
    >
      {{ condition.name }}
    </mat-list-option>
    }
  </mat-selection-list>
  }
</div>
} @if (mode === 'switch') {
<div class="grid grid-cols-1 gap-6 w-full">
  @for ( condition of filter === 'VEHICLE' ? vehicleConditions : filter ===
  'DRIVER' ? driverConditions : filter === 'TRAVELLER' ? travellerConditions :
  filter === 'BOOKING' ? jobConditions : filter === 'ORGANISATION' ?
  organisationConditions : filter === 'MEDALLION' ? medallionConditions : [];
  track condition; let i = $index) {
  <fleet-toggle-with-left-label-and-description
    class="w-full"
    [disabled]="
      formControl.disabled ||
      isConditionProcessing(condition.networkConditionId)
    "
    [formControl]="$any(conditionsFormArray.controls[i])"
    [title]="condition.name"
    [description]="condition.description"
    [clickableLabel]="false"
    (checkedChange)="toggleCondition(condition, $event)"
  ></fleet-toggle-with-left-label-and-description>
  }
</div>
} } @else {
<div class="flex justify-center p-6">
  <mat-spinner [diameter]="24"></mat-spinner>
</div>
}
